module.exports = __webpack_public_path__ + "static/media/00-alles_falsch.16c7af20.jpg";